import { ApiError } from "@/pages/auth/api";
import { API_BASE_URL } from "@/shared/config/apiBaseUrl";

export type SiteNoticeTone = "info" | "warning" | "success" | "critical";

export type SiteNotice = {
  enabled: boolean;
  notice_id: string | null;
  title: string | null;
  body: string | null;
  tone: SiteNoticeTone;
  cta_label: string | null;
  cta_url: string | null;
  updated_at: string | null;
};

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let detail = `request failed with status ${response.status}`;
    try {
      const payload = (await response.json()) as { detail?: string };
      if (payload.detail) {
        detail = payload.detail;
      }
    } catch {
      // Keep fallback detail.
    }
    throw new ApiError(detail, response.status);
  }
  return (await response.json()) as T;
}

export async function getSiteNotice(): Promise<SiteNotice> {
  const response = await fetch(`${API_BASE_URL}/api/site-notice`);
  return parseJson<SiteNotice>(response);
}
